
import './marketers.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import user from '../../service/user';
import marketer from '../../service/marketer';

import menuLayout from '../../directive/menu-layout';
import customTable from '../../directive/custom-table';

import routing from './marketers.routes';
import MarketersController from './marketers.controller';

export default angular.module('page.marketers', [
		uirouter,
		menuLayout,
		marketer,
		user,
		customTable
	])
	.config(routing)
	.controller('MarketersController', MarketersController)
	.name;



// WEBPACK FOOTER //
// ./src/page/marketers/index.js